import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import axios from "axios";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import NavBarTitles from "../../components/Common/TabBar";

const DownloadLinkBanner = ({ setPlatform }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [platforms, setPlatforms] = useState([]);
  const addNewLegalPage = {
    id: "addnewpost",
    onClick: () =>
      navigate(
        `/app-download-link/${location.pathname.split("/")[2]}/add-new-app-link`,
      ),
    style: { width: "240px" },
    label: "Add New Legal Page",
  };
  const currentSlug = location.pathname.split("/")[2];

  const convertToSlug = (name) => name?.replace(/\s+/g, "-").toLowerCase();

  const fetchPlatforms = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}platform-name/list`,
      );
      setPlatforms(res.data.rows || []);
    } catch (err) {
      console.error("Failed to fetch platform names", err);
    }
  };

  useEffect(() => {
    fetchPlatforms();
  }, [currentSlug]);

  useEffect(() => {
    if (platforms.length > 0) {
      const platform = platforms.find(
        (p) => convertToSlug(p.platform_name) === currentSlug,
      );
      setPlatform(platform || null);
    }
  }, [platforms]);

  const breadcrumbsList = [
    { text: "Legal Pages", link: "" },
    {
      text:
        platforms.find((p) => convertToSlug(p.platform_name) === currentSlug)
          ?.platform_name || "",
      link: "",
    },
  ];

  // const tabs = platforms.map((item) => ({
  //   name: item.platform_name,
  //   navigatePath: `/app-download-link/${convertToSlug(item.platform_name)}`,
  // }));

  const tabs = [
    {
      name: "Website",
      navigatePath: `/app-download-link/website`,
    },
    // {
    //   name: "User App",
    //   navigatePath: `/app-download-link/user-app`,
    // },
    {
      name: "Doctor",
      navigatePath: `/app-download-link/doctor-app`,
    },
    {
      name: "Pharmacy",
      navigatePath: `/app-download-link/pharmacy-app`,
    },
    {
      name: "HHSP",
      navigatePath: `/app-download-link/hhsp-app`,
    },
    // {
    //   name: "Delivery Partner App",
    //   navigatePath: `/app-download-link/delivery-partner-app`,
    // },
    {
      name: "InstaDoc",
      navigatePath: `/app-download-link/instadoc`,
    },
    // {
    //   name: "Legal Notes",
    //   navigatePath: `/app-download-link/legal-notes`,
    // },
    {
      name: "Collaborate with us",
      navigatePath: `/app-download-link/collaborate-with-us`,
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs pb-2"
          breadcrumbsList={breadcrumbsList}
        />
        <FilledButton props={addNewLegalPage} />
      </div>
      <div className="my-3">
        <NavBarTitles titles={tabs} />
      </div>
    </>
  );
};

export default DownloadLinkBanner;
